// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"d7d62998","328":"62154909"}[chunkId] + ".chunk.css";
};